module.exports = __webpack_public_path__ + "87f672e801b9bce1ea2204649a772764.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/santa-hat-s.png
// module id = 2786
// module chunks = 0